<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-09-03 17:20:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-08-06 10:06:42
 * @FilePath: \vue-app-console\src\views\Firmware\SearchForm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="search_form">
        <a-select 
            v-if="userInfo.tenant_id == 1"
            class="query_field" 
            v-model:value="formData.sys_org"
            style="width: 150px; margin: 0 10px 5px 0"
            :placeholder="t('account.tenant')" 
            :options="props.tenantOptions" 
            @change="handleSelectChange('tenant')"
        ></a-select>

        <!-- <a-input v-model:value="formData.project_no" allowClear :placeholder="t('firmware.project_no')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('project_no')"/> -->
        <!-- <a-input v-model:value="formData.company_id" allowClear :placeholder="t('firmware.company_id')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('company_id')"/> -->
        <!-- <a-input v-model:value="formData.part_no" allowClear :placeholder="t('firmware.part_no')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('part_no')"/> -->
        <a-input v-model:value="formData.file_name" allowClear :placeholder="t('firmware.file_name')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('file_name')"/>
        <a-input :value="formData.hardware_version" allowClear :placeholder="t('firmware.hardware_version')" style="width: 150px; margin: 0 10px 5px 0" @input="e => handleVersionInput(e, 'hardware_version')"/>
        <a-input :value="formData.software_version" allowClear :placeholder="t('firmware.software_version')" style="width: 150px; margin: 0 10px 5px 0" @input="e => handleVersionInput(e, 'software_version')"/>
        
        <!-- <a-select 
            class="query_field" 
            v-model:value="formData.status" 
            allowClear
            showSearch
            style="width: 150px; margin: 0 10px 5px 0"
            :placeholder="t('firmware.firmwareStatus')" 
            :options="statusOptions"
            @change="handleSelectChange('firmware_status')"
        ></a-select> -->
        <!-- <a-select 
            class="query_field" 
            v-model:value="formData.environment" 
            allowClear
            showSearch
            style="width: 200px; margin: 0 10px 5px 0"
            :placeholder="t('firmware.environment')" 
            :options="environmentOptions" 
            @change="handleSelectChange('environment')"
        ></a-select> -->
        <!-- <a-select 
            class="query_field" 
            v-model:value="formData.release_limit" 
            allowClear
            showSearch
            style="width: 150px; margin: 0 10px 5px 0"
            :placeholder="t('firmware.release_limit')" 
            :options="releaseLimitOptions" 
            @change="handleSelectChange('release_limit')"
        ></a-select> -->

            
        <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
            <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
            {{ $t('base.search') }}
        </a-button>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from "vue";
    import { LoginApi } from '@/api/LoginApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { useI18n } from 'vue-i18n';
    const { t } = useI18n()

    const props = defineProps({
        tenantOptions: {
            type: Array,
            default: () => [],
        },
    })
    
    const emits = defineEmits([
        'handleInputChange',
        'handleSearch',
        'handleSelectChange',
    ])

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    // const tenantOptions = ref([])
    const formData = reactive({
        // project_no: '',
        // company_id: '',
        // part_no: '',
        file_name: '',
        hardware_version: '',
        software_version: '',
        // status: null,
        // environment: null,
        release_limit: null,
        sys_org: null,
    })

    const statusOptions = ref([
        { label: t('firmware.published'), value: '0' },
        { label: t('firmware.testing'), value: '1' },
        { label: t('firmware.not_used'), value: '2' },
    ])
    const environmentOptions = ref([
        { label: t('firmware.market_environment'), value: '0' },
        // { label: t('firmware.testing_environment'), value: '1' },
        // { label: t('firmware.production_environment'), value: '2' },
    ])
    const releaseLimitOptions = ref([
        { label: t('firmware.unlimited'), value: '0' },
        // { label: t('firmware.base'), value: '1' },
        // { label: t('firmware.grayscale'), value: '2' },
        { label: t('firmware.personal'), value: '3' },
        { label: t('firmware.frameNumber'), value: '5' },
        { label: t('firmware.assemblyCode'), value: '4' },
        { label: t('firmware.sku'), value: '6' },
    ])

    const handleInputChange = (key) => {
        console.log(key, 'input key')
        // formData[key] = e.target.value
        emits('handleInputChange',formData)
    }

    
    const handleVersionInput = (e, key) => {
        const rawValue = e.target.value
        const filteredValue = rawValue.replace(/[^0-9.]/g, '')
        // 去除所有小数点后，整数值不能超过 int 最大值 2147483647
        const intValue = Number(filteredValue.replace(/\./g, ''))
        if (intValue > 2147483647) {
            e.target.value = formData[key]
            return
        }
        // 直接修正原生 input 的 value，确保界面上不显示非法字符
        if (rawValue !== filteredValue) {
            e.target.value = filteredValue
        }
        formData[key] = filteredValue
        emits('handleInputChange',formData)
    }

    const handleSelectChange = (key) => {
        console.log(key, 'select key')
        // formData[key] = e.target.value  
        emits('handleInputChange',formData)
    }

    const handleSearch = () => {
        console.log(formData,'formData')
        emits('handleSearch',formData)
    }

    
    defineExpose({
        formData
    })

    onMounted(()=>{

    })

</script>

<style lang="scss" scoped>
.search_form{
    margin: 30px 0 15px;
}
</style>